<style></style>

<template>
  <section class="dicas" id="Search">
    <div class="container">
      <!-- Breadcrumb -->
      <div class="row p-25">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a class="text-uppercase" href="#">Início</a>
              </li>
              <li
                class="breadcrumb-item active text-uppercase"
                aria-current="page"
              >
                Search
              </li>
              <li
                class="breadcrumb-item active text-uppercase"
                aria-current="page"
              >
                {{ pesq }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <!-- Título -->
      <div class="row mb-5">
        <div class="col-12 mb-4 text-center">
          <h1 class="h1-after-center text-uppercase fwb mb-4">
            Resultados da Pesquisa: {{ pesq }}
          </h1>
        </div>
      </div>
      <!-- 6 Cards -->
      <div class="row mb-5" v-if="pesquisaItens !== []">
        <div class="col-md-12 mb-4" v-for="(Search, index) in pesquisaItens">
          <div class="card-dica" v-if="Search.tipo === 'profissional'">
            <div class="p-3 border-bottom" v-if="Search.nome_fantasia !== null">
              <h3 class="mb-0 text-uppercase">{{ Search.nome_fantasia }}</h3>
            </div>
            <div class="p-3 border-bottom" v-else-if="Search.nome !== null">
              <h3 class="mb-0 text-uppercase">{{ Search.nome }}</h3>
            </div>
            <div class="p-3 border-bottom">
              <div class="fs-14 roboto-n">
                Veja sobre o profissional no botão abaixo!
              </div>
            </div>
            <div class="p-3">
              <router-link
                class="btn btn-sm bg-orange c-white mt-2"
                :to="{
                  name: 'guia-profissionais-single',
                  params: { id: Search.id },
                }"
                >Ver Mais</router-link
              >
            </div>
          </div>
          <div class="card-dica" v-else-if="Search.tipo === 'dica'">
            <div class="p-3 border-bottom">
              <h3 class="mb-0 text-uppercase">{{ Search.titulo }}</h3>
            </div>
            <div class="p-3 border-bottom">
              <div class="fs-14 roboto-n" v-if="Search.texto_1 !== null">
                {{ Search.texto_1.substring(0, 200) + ' ...' }}
              </div>
              <div class="fs-14 roboto-n" v-else-if="Search.texto_2 !== null">
                {{ Search.texto_2.substring(0, 200) + ' ...' }}
              </div>
            </div>
            <div class="p-3">
              <router-link
                class="btn btn-sm bg-orange c-white mt-2"
                :to="{ name: 'blog-single', params: { id: Search.id } }"
                >Ver Mais</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5" v-else>
        <div class="col-md-12 mb-4">
          <div class="card-dica">
            <div class="p-3 border-bottom">
              <h3 class="mb-0 text-uppercase">Desculpe!</h3>
            </div>
            <div class="p-3 border-bottom">
              <div class="fs-14 roboto-n">Não foi possível encontrar nada!</div>
            </div>
            <div class="p-3">
              <router-link
                class="btn btn-sm bg-orange c-white mt-2"
                :to="{ name: 'home' }"
                >Ver Mais</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Search',
  props: ['pesq'],
  data() {
    return {};
  },
  created() {
    this.search(this.replaceSpecialChars(this.pesq.toLowerCase()));
  },
  computed: {
    ...mapGetters([
      // Mapeamento de getters
      'getToken',
      'getTipoNotification',
      'getNotification',
    ]),
    ...mapState([
      // Mapeamento de states
      'token',
      'dadosUsuario',
      'pesquisaItens',
    ]),
  },
  watch: {
    '$route.params.pesq': function (pesq) {
      this.search(this.replaceSpecialChars(pesq.toLowerCase()));
    },
  },
  methods: {
    search(value) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('searchData', value)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        });
    },
    replaceSpecialChars(str) {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .replace(/([^\w]+|\s+)/g, ' ') // Substitui espaço e outros caracteres por hífen
        .replace(/\-\-+/g, ' ') // Substitui multiplos hífens por um único hífen
        .replace(/(^-+|-+$)/, ''); // Remove hífens extras do final ou do inicio da string
    },
  },
};
</script>
